import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DATE_FORMATS, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { QuillModule } from 'ngx-quill';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TreoCardModule } from 'tsui/@treo';
import moment from 'moment';
import { TreoAutogrowModule } from 'tsui/@treo';
import { TreoFindByKeyPipeModule } from 'tsui/@treo';
import { TreoMessageModule } from 'tsui/@treo';
import { MatChipsModule } from '@angular/material/chips';

import { MassUpdateTagsDialog } from './mass-update-tags/mass-update-tags.component';
import { EditTabTitleModalComponent } from './edit-tab-title-modal/edit-tab-title-modal.component';
import { EditSelectModalComponent } from './edit-custom-field-select/edit-custom-field-select.component';
import { GenerateMergeDocumentComponent } from './generate-merge-document/generate-merge-document.component';
import { WidgetsModule } from '../components/widgets/widgets.module';
import { AlertBannerComponent } from '../components/widgets/alert-banner/alert-banner.component';
import { PanelConditionalLogicModal } from './panel-conditional-logic-modal/panel-conditional-logic-modal.component';
import { EthanFormFieldSelectionModal } from './ethan-form-field-selection-modal/ethan-form-field-selection-modal.component';
import { FormFieldsModule } from '../components/form-fields/form-fields.module';

import { TsButtonModule } from 'tsui';
import { TsSelectModule } from 'tsui/lib/ts-select/ts.select.module';
import { TsCheckboxComponent } from 'tsui';

@NgModule({
  declarations: [
    EditTabTitleModalComponent,
    EditSelectModalComponent,
    GenerateMergeDocumentComponent,
    MassUpdateTagsDialog,
    PanelConditionalLogicModal,
    EthanFormFieldSelectionModal,
  ],
  imports: [
    CommonModule,
    TsCheckboxComponent,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    TreoCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatMenuModule,
    MatMomentDateModule,
    MatProgressBarModule,
    MatRippleModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatPaginatorModule,
    MatSidenavModule,
    MatTableModule,
    MatTooltipModule,
    MatSnackBarModule,
    QuillModule.forRoot(),
    TreoAutogrowModule,
    MatChipsModule,
    TreoFindByKeyPipeModule,
    TreoMessageModule,
    WidgetsModule,
    TsButtonModule,
    TsSelectModule,
    FormFieldsModule,
    AlertBannerComponent,
  ],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: moment.ISO_8601,
        },
        display: {
          dateInput: 'LL',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class ModalsModule {}
